var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,0c141.384,0,256,114.616,256,256S397.384,512,256,512c0-11.13-33.391-256-33.391-256L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,512C114.616,512,0,397.384,0,256S114.616,0,256,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M354.03,222.765l48.111,63.646c-7.58,11.478-7.54,26.942,1.227,38.539 c11.12,14.711,32.061,17.623,46.773,6.502c14.711-11.12,17.623-32.061,6.501-46.772c-8.765-11.597-23.633-15.853-36.743-11.691 l-74.981-99.193l-17.758,13.424l-26.64,20.134l26.848,35.515L354.03,222.765z M423.293,295.935 c4.904-3.708,11.885-2.736,15.592,2.166c3.706,4.904,2.737,11.885-2.167,15.593c-4.903,3.705-11.884,2.737-15.59-2.168 C417.419,306.622,418.39,299.641,423.293,295.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M436.55,242.868l26.848-35.515l-26.638-20.136l-17.758-13.424l-74.981,99.193 c-13.108-4.162-27.977,0.095-36.743,11.691c-11.122,14.712-8.21,35.652,6.501,46.772c14.712,11.12,35.652,8.209,46.772-6.502 c8.766-11.597,8.806-27.061,1.227-38.539l48.111-63.646L436.55,242.868z M342.793,311.525c-3.706,4.905-10.686,5.874-15.59,2.168 c-4.904-3.708-5.874-10.689-2.167-15.593c3.706-4.902,10.687-5.874,15.592-2.166C345.531,299.641,346.5,306.622,342.793,311.525z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.fb1f1aecb170b75675c4178ac4cc2e5c.svg";
export { ForwardRef as ReactComponent };